import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import './index.css'

// cSpell:disable
import VueClickAway from 'vue3-click-away'
import { FontAwesomeIcon } from './plugins/font-awesome.js'
// cSpell:enable

import HighchartsVue from 'highcharts-vue'
import AppLayout from './layouts/AppLayout.vue'

import * as Sentry from '@sentry/vue'
// import { BrowserTracing } from '@sentry/tracing'

import '@fortawesome/fontawesome-svg-core/styles.css'

const app = createApp(App)

app.config.globalProperties.$nonce = document.querySelector('meta[name=csp-nonce]')?.getAttribute('content')

let replay = null

if (import.meta.env.MODE !== 'production') {

    app.config.devtools = true
    app.config.performance = true

} else {

    replay = Sentry.replayIntegration({
        blockAllMedia: false,
        maskAllText: false,
        maskAllInputs: false,
        networkDetailAllowUrls: [/\/api\/.+/],
    })

	Sentry.init({
        app,
        dsn: 'https://fa21ac8c31c344cfa5872a8a1286437b@o1088711.ingest.sentry.io/6180936',
        environment: import.meta.env.MODE,
        integrations: [
            // When enabling Sentry replays, it's also necessary to adjust the CSP headers to include "worker-src blob:" -- which is risky.
            replay,
        ],
        tracesSampleRate: 0.1,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,
    })

}

const config = JSON.parse(document.getElementById('config').innerHTML)

store.commit('workspaceAuthSettings', {
	workspaceDefaultVersion: config?.workspaceDefaultVersion ?? import.meta.env.VITE_WORKSPACE_DEFAULT_VERSION ?? '2.0',
	workspaceName: config?.workspaceName ?? import.meta.env.VITE_WORKSPACE_NAME,
	workspaceUuid: config?.workspace ?? import.meta.env.VITE_WORKSPACE_UUID,
	subdomain: config?.subdomain ?? import.meta.env.VITE_WORKSPACE_SUBDOMAIN,
	samlSlug: config?.samlSlug ?? import.meta.env.VITE_WORKSPACE_SAML_SLUG,
	allowVersionSwitch: config?.allowVersionSwitch ?? (import.meta.env.VITE_ALLOW_VERSION_SWITCH === 'true') ?? null,
	samlRequired: config?.samlRequired ?? JSON.parse(import.meta.env.VITE_WORKSPACE_SAML_REQUIRED ?? 'null'),
})

if (sessionStorage.getItem('impersonatingWorkspace')) {
//	store.commit('setImpersonatedWorkspace', {uuid: sessionStorage.getItem('impersonatingWorkspace')})
}

app.config.globalProperties.window = window

app.use(store)
    .use(router)
    .use(HighchartsVue)
    .use(VueClickAway)
    .provide('window', app.config.globalProperties.window)
    .provide('sentryReplay', replay)
    .component('AppLayout', AppLayout)
    .component('font-awesome-icon', FontAwesomeIcon)
    .mount('#app')
